module.exports = __webpack_public_path__ + "assets/fonts/opensans-regular_29566b6.eot";